import "./app.scss";
import "./js/index";


const $formModal = $("section.js-modal");
const $successModal = $("section.js-modal-success");
const $form = $("#user-request-form");
const $goalBlock = $("#goal-block");

const recaptchaWidgetId = $form.find(".recaptcha").data("widget-uuid");

function setError(form, field, error) {
const $div = form
  .find(`div.form__item input[name="${field}"]`)
  .parents("div.form__item");
$div.addClass("error-item");
$div.find("input").addClass("error");
$div.append(`<div class="error__tooltip"><span>${error}</span></div>`);
}

function setGoalError(form, error) {
$goalBlock.addClass("error");
}

function removeErrors(form) {
const $elements = form.find(`div.form__item`);
$elements.removeClass("error-item");
for (let index = 0; index < $elements.length; index++) {
  const $element = $($elements[index]);
  $element.find("input").removeClass("error");
  $element.find("div.error__tooltip").remove();
}
if (form == $form) {
  $goalBlock.removeClass("error");
}
}

const $userForm = $("#user-request-form");
const $userSubmitButton = $userForm.find('[type="submit"]');

//   window[`reCaptchaonSubmit_${recaptchaWidgetId}`] = (data, widgetId) => {
//     let phone = $userForm.find(".js-select-phone").val() + mask.unmaskedValue;
//     let serialize = $userForm.serializeArray().map((item) => {
//       if (item.name === "phone_number") {
//         item.value = phone;
//       }
//       return item;
//     });

//     $userSubmitButton.addClass("form__submit--load");
//     $userSubmitButton.prop("disabled", true);
//     removeErrors($userForm);

//     $.ajax({
//       url: $userForm.attr("action"),
//       method: "post",
//       data: serialize,
//     })
//       .done((res) => {
//         if (res.status) {
//           $formModal.removeClass("active");
//           $userForm.trigger("reset");
//           $userForm.find(".select2").val("");
//           $userForm.find(".select2").trigger("change");
//           mask.destroy();
//           $userForm.find(".js-flag-img").addClass("flag-doesnt-exist");
//           $userForm.find(".js-flag-img").text("");
//           $userForm.find(".js-flag-code").text("Choose your country");
//           if (window.ANALYTICS_ENABLED == true) {
//             (dataLayer = window.dataLayer || []).push({
//               eCategory: "Form",
//               eAction: "sent",
//               eLabel: "",
//               event: "GTMForms",
//             });
//           }
//           setTimeout(() => {
//             $successModal.addClass("active");
//           }, 500);
//         } else {
//           for (const [field, errors] of Object.entries(res.form_errors)) {
//             if (["goal", "other_field_value"].indexOf(field) === -1) {
//               setError($userForm, field, errors[0]);
//             } else {
//               setGoalError(errors[0]);
//             }
//           }
//         }
//       })
//       .fail((response) => {})
//       .always(() => {
//         grecaptcha.reset(widgetId);
//         $userSubmitButton.removeClass("form__submit--load");
//       });
//     return false;
//   };

$userForm.on('submit', function(e) {
let phone = $userForm.find(".js-select-phone").val() + mask.unmaskedValue;
let serialize = $userForm.serializeArray().map((item) => {
  if (item.name === "phone_number") {
    item.value = phone;
  }
  return item;
});

$userSubmitButton.addClass("form__submit--load");
$userSubmitButton.prop("disabled", true);
removeErrors($userForm);

$.ajax({
  url: $userForm.attr("action"),
  method: "post",
  data: serialize,
})
  .done((res) => {
    if (res.status) {
      $formModal.removeClass("active");
      $userForm.trigger("reset");
      $userForm.find(".select2").val("");
      $userForm.find(".select2").trigger("change");
      mask.destroy();
      $userForm.find(".js-flag-img").addClass("flag-doesnt-exist");
      $userForm.find(".js-flag-img").text("");
      $userForm.find(".js-flag-code").text("Choose your country");
      if (window.ANALYTICS_ENABLED == true) {
        gtag('event', 'Form Submit', {
            'eCategory': 'Form Main',
            'eAction': 'Submit',
            'eLabel': 'Form'
        })
      }
      setTimeout(() => {
        $successModal.addClass("active");
      }, 500);
    } else {
      for (const [field, errors] of Object.entries(res.form_errors)) {
        if (["goal", "other_field_value"].indexOf(field) === -1) {
          setError($userForm, field, errors[0]);
        } else {
          setGoalError(errors[0]);
        }
      }
    }
  })
  .fail((response) => {})
  .always(() => {
    $userSubmitButton.removeClass("form__submit--load");
  });
return false;
})

const $shortForm = $("#short-user-request-form");
const $shortSubmitButton = $shortForm.find('[type="submit"]');
const shortRecaptchaWidgetId = $shortForm
.find(".recaptcha")
.data("widget-uuid");

// window[`reCaptchaonSubmit_${shortRecaptchaWidgetId}`] = (data, widgetId) => {
//     let phone = $shortForm.find('.js-select-phone').val() + mask.unmaskedValue
//     let serialize = $shortForm.serializeArray().map(item => {
//         if (item.name === 'phone_number') {
//             item.value = phone
//         }
//         return item
//     })

//     $shortSubmitButton.addClass('form__submit--load')
//     $shortSubmitButton.prop('disabled', true)
//     removeErrors($shortForm)

//     $.ajax({
//         url: $shortForm.attr('action'),
//         method: 'post',
//         data:  serialize
//     }).done((res) => {
//         if (res.status) {
//             $shortForm.closest('.js-short-form').removeClass('over transition active')
//             $shortForm.trigger('reset')
//             $shortForm.find('.select2').val('')
//             $shortForm.find('.select2').trigger('change')
//             mask.destroy()
//             $shortForm.find('.js-flag-img').addClass('flag-doesnt-exist')
//             $shortForm.find('.js-flag-img').text('')
//             $shortForm.find('.js-flag-code').text('Choose your country')
//             if (window.ANALYTICS_ENABLED == true) {
//                 (dataLayer = window.dataLayer || []).push({
//                    'eCategory': 'Form',
//                    'eAction': 'sent',
//                    'eLabel': '',
//                    'event': 'GTMForms'
//                 });
//             }
//             setTimeout(() => {
//                 $successModal.addClass('active')
//             }, 500)
//         } else {
//             for (const [field, errors] of Object.entries(res.form_errors)) {
//                 if (['goal', 'other_field_value'].indexOf(field) === -1) {
//                     setError($shortForm, field, errors[0])
//                 } else {
//                     setGoalError(errors[0])
//                 }
//             }
//         }
//     }).fail((response) => {

//     }).always(() => {
//         grecaptcha.reset(widgetId)
//         $userSubmitButton.removeClass('form__submit--load')
//     })
//     return false
// }

$shortForm.on("submit", function (e) {
let phone = $shortForm.find(".js-select-phone").val() + mask.unmaskedValue;
let serialize = $shortForm.serializeArray().map((item) => {
  if (item.name === "phone_number") {
    item.value = phone;
  }
  return item;
});

$shortSubmitButton.addClass("form__submit--load");
$shortSubmitButton.prop("disabled", true);
removeErrors($shortForm);

$.ajax({
  url: $shortForm.attr("action"),
  method: "post",
  data: serialize,
})
  .done((res) => {

    if (res.status) {
      $shortForm
        .closest(".js-short-form")
        .removeClass("over transition active");
      $shortForm.trigger("reset");
      $shortForm.find(".select2").val("");
      $shortForm.find(".select2").trigger("change");
      mask.destroy();
      $shortForm.find(".js-flag-img").addClass("flag-doesnt-exist");
      $shortForm.find(".js-flag-img").text("");
      $shortForm.find(".js-flag-code").text("Choose your country");
      if (window.ANALYTICS_ENABLED == true) {
          gtag('event', 'Form Submit', {
            'eCategory': 'Form Main',
            'eAction': 'Submit',
            'eLabel': 'Form'
        })
      }
      setTimeout(() => {
        $successModal.addClass("active");
      }, 500);
    } else {
      for (const [field, errors] of Object.entries(res.form_errors)) {
        if (["goal", "other_field_value"].indexOf(field) === -1) {
          setError($shortForm, field, errors[0]);
        } else {
          setGoalError(errors[0]);
        }
      }
    }
  })
  .fail((response) => {})
  .always(() => {
    // grecaptcha.reset(widgetId);
    $shortSubmitButton.removeClass("form__submit--load");
  });
return false;
});

const $shortForm2 = $("#short-user-request-form2");
const $shortSubmitButton2 = $shortForm2.find('[type="submit"]');
const shortRecaptchaWidgetId2 = $shortForm
.find(".recaptcha")
.data("widget-uuid");

// window[`reCaptchaonSubmit_${shortRecaptchaWidgetId}`] = (data, widgetId) => {
//     let phone = $shortForm.find('.js-select-phone').val() + mask.unmaskedValue
//     let serialize = $shortForm.serializeArray().map(item => {
//         if (item.name === 'phone_number') {
//             item.value = phone
//         }
//         return item
//     })

//     $shortSubmitButton.addClass('form__submit--load')
//     $shortSubmitButton.prop('disabled', true)
//     removeErrors($shortForm)

//     $.ajax({
//         url: $shortForm.attr('action'),
//         method: 'post',
//         data:  serialize
//     }).done((res) => {
//         if (res.status) {
//             $shortForm.closest('.js-short-form').removeClass('over transition active')
//             $shortForm.trigger('reset')
//             $shortForm.find('.select2').val('')
//             $shortForm.find('.select2').trigger('change')
//             mask.destroy()
//             $shortForm.find('.js-flag-img').addClass('flag-doesnt-exist')
//             $shortForm.find('.js-flag-img').text('')
//             $shortForm.find('.js-flag-code').text('Choose your country')
//             if (window.ANALYTICS_ENABLED == true) {
//                 (dataLayer = window.dataLayer || []).push({
//                    'eCategory': 'Form',
//                    'eAction': 'sent',
//                    'eLabel': '',
//                    'event': 'GTMForms'
//                 });
//             }
//             setTimeout(() => {
//                 $successModal.addClass('active')
//             }, 500)
//         } else {
//             for (const [field, errors] of Object.entries(res.form_errors)) {
//                 if (['goal', 'other_field_value'].indexOf(field) === -1) {
//                     setError($shortForm, field, errors[0])
//                 } else {
//                     setGoalError(errors[0])
//                 }
//             }
//         }
//     }).fail((response) => {

//     }).always(() => {
//         grecaptcha.reset(widgetId)
//         $userSubmitButton.removeClass('form__submit--load')
//     })
//     return false
// }

$shortForm2.on("submit", function (e) {
let phone = $shortForm2.find(".js-select-phone").val() + mask.unmaskedValue;
let serialize = $shortForm2.serializeArray().map((item) => {
  if (item.name === "phone_number") {
    item.value = phone;
  }
  return item;
});

$shortSubmitButton2.addClass("form__submit--load");
$shortSubmitButton2.prop("disabled", true);
removeErrors($shortForm2);

$.ajax({
  url: $shortForm2.attr("action"),
  method: "post",
  data: serialize,
})
  .done((res) => {

    if (res.status) {
      $shortForm2
        .closest(".js-short-form-modal")
        .removeClass("over transition active");
      $shortForm2.trigger("reset");
      $shortForm2.find(".select2").val("");
      $shortForm2.find(".select2").trigger("change");
      mask.destroy();
      $shortForm2.find(".js-flag-img").addClass("flag-doesnt-exist");
      $shortForm2.find(".js-flag-img").text("");
      $shortForm2.find(".js-flag-code").text("Choose your country");
      if (window.ANALYTICS_ENABLED == true) {
        gtag('event', 'Form Submit', {
            'eCategory': 'Form Main',
            'eAction': 'Submit',
            'eLabel': 'Form'
        })
      }
      setTimeout(() => {
        $successModal.addClass("active");
      }, 500);
    } else {
      for (const [field, errors] of Object.entries(res.form_errors)) {
        if (["goal", "other_field_value"].indexOf(field) === -1) {
          setError($shortForm2, field, errors[0]);
        } else {
          setGoalError(errors[0]);
        }
      }
    }
  })
  .fail((response) => {})
  .always(() => {
    // grecaptcha.reset(widgetId);
    $shortSubmitButton2.removeClass("form__submit--load");
  });
return false;
});

